import { panelTeaserFactory } from "@components/Teaser/Teaser"
import Asset from "./Asset"
import FeedTrivia from "./Trivia"
import { Panel, Body } from "@components/Teaser/Panel"
import withLegacyPropsMap from "@components/content-feed/util/hoc/withLegacyPropsMap";
import withProps from "@util/hoc/withProps";
import Template from "./Template"

/**
 * Hide button if there is no view_action
 */
const FeedBody = withProps(Body, ({ buttonText, ...props }) => ({
  ...props,
  buttonText: props.view_action && buttonText,
}))

const defaultComponents = {
  Asset,
  Trivia: FeedTrivia,
  Body: FeedBody,
  Template,
}

const feedTeaserFactory = ({ displayName, className, ...props }) => {
  return withLegacyPropsMap(
    panelTeaserFactory({
      ...defaultComponents,
      displayName,
      Wrapper: className && withProps(Panel, { className }),
      ...props,
    })
  )
}

export default feedTeaserFactory
